import React from 'react';
import {Navigate, useParams} from "react-router-dom";

const RedirectOldMenuAdd = () => {
    const {id} = useParams();

    return <Navigate to={`/menu/add/${id}`} replace/>;

}

export default RedirectOldMenuAdd;